import apiApp from "./index";

const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
const token = localStorage.getItem("UserjwtToken");
const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));

// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

// Helper: build subTenantDTO for request body
const getSubTenantDTO = () => {
    return decodedToken?.isMultitenancy && decodedToken?.subTenantId
        ? { id: decodedToken.subTenantId }
        : null;
};

// Common headers
const getHeaders = () => {
    const headers = {
        Authorization: `Bearer ${token}`,
        "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };

    // only tenant-admin OR if subTenantId is missing
    if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
        headers["tenant-login"] = true;
    }

    return headers;
};

const ReportsApi = {
    // Export Raw Waste Report
    ExportRawWasteReport: (startDate, endDate) => {
        const url = `/reports/rawWaste/export/excel?startDate=${startDate}&endDate=${endDate}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
        return apiApp
            .get(url, { headers: getHeaders(), responseType: 'blob' })
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },

    ExportExpiredStock: (startDate, endDate) => {
        const url = `/reports/expiredStock/export/excel?startDate=${startDate}&endDate=${endDate}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
        return apiApp
            .get(url, { headers: getHeaders(), responseType: 'blob' })
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },

    CleaningTraceability: (startDate, endDate, frequency) => {
        return apiApp
            .get(
                `/cleaningTaskInstance/report?startDate=${startDate}&endDate=${endDate}&frequency=${frequency}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                { headers: getHeaders() }
            )
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },

    ExportCleaningReport: (startDate, endDate) => {
        const url = `/reports/cleaning/export/excel?startDate=${startDate}&endDate=${endDate}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
        return apiApp
            .get(url, { headers: getHeaders(), responseType: 'blob' })
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },

    StockAdjustmentReport: (page, size) => { 
        return apiApp
            .get(
                `/stockAdjustment?sort=desc&page=${page}&size=${size}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                { headers: getHeaders() }
            )
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },

    AfterCookReport: (startDate, endDate) => {
        return apiApp
            .get(
                `/afterCook/report?startDate=${startDate}&endDate=${endDate}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                { headers: getHeaders() }
            )
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },

    ColdTraceabilityReport: (startDate, endDate) => {
        return apiApp
            .get(
                `/coldTraceability/report?startDate=${startDate}&endDate=${endDate}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                { headers: getHeaders() }
            )
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },

    HotHoldReport: (startDate, endDate) => {
        return apiApp
            .get(
                `/hotHold/report?startDate=${startDate}&endDate=${endDate}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                { headers: getHeaders() }
            )
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },

    CoolingProcessReport: (startDate, endDate) => {
        return apiApp
            .get(
                `/cooling-processes/report?startDate=${startDate}&endDate=${endDate}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                { headers: getHeaders() }
            )
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },

    ReheatProcessReport: (startDate, endDate) => {
        return apiApp
            .get(
                `/reheat-processes/report?startDate=${startDate}&endDate=${endDate}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                { headers: getHeaders() }
            )
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },

    DashboardWeeklyCogs: (thisWeekStart, thisWeekEnd) => {
        return apiApp
            .get(
                `/dashboard/weekly-cogs?thisWeekStart=${thisWeekStart}&thisWeekEnd=${thisWeekEnd}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                { headers: getHeaders() }
            )
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },

    DashboardWasteBreakdown: (startDate, endDate) => {
        return apiApp
            .get(
                `/dashboard/waste-breakdown?startDate=${startDate}&endDate=${endDate}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                { headers: getHeaders() }
            )
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },

     DashboardUnitHeatGrid: (startDate, endDate) => {
        return apiApp
            .get(
                `/dashboard/unit-heat-grid?startDate=${startDate}&endDate=${endDate}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                { headers: getHeaders() }
            )
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },

    DashboardHotHoldCompliance: (startDate, endDate) => {
        return apiApp
            .get(
                `/dashboard/hot-hold-compliance?startDate=${startDate}&endDate=${endDate}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                { headers: getHeaders() }
            )
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },

    SaveDashboardHotHoldConfig: (data) => {
        const jsonData = typeof data === "string" ? JSON.parse(data) : data;

        // Add tenantDTO
        if (decodedToken?.tenantId) {
            jsonData.tenantDTO = {
                id: decodedToken.tenantId,
                tenantApiKey: decodedToken.tenantApiKey,
            };
        }

        // Add subTenantDTO if exists
        const subTenantDTO = getSubTenantDTO();
        if (subTenantDTO) {
            jsonData.subTenantDTO = subTenantDTO;
        }

        return apiApp
            .post(`/hotHoldConfig`, JSON.stringify(jsonData), {
                headers: getHeaders(),
            })
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },

    UpdateDashboardHotHoldConfig: (hotHoldConfigId, data) => {
        const jsonData = typeof data === "string" ? JSON.parse(data) : data;

        jsonData.tenantDTO = {
            id: decodedToken?.tenantId,
            tenantApiKey: decodedToken?.tenantApiKey,
        };

        const subTenantDTO = getSubTenantDTO();
        if (subTenantDTO) {
            jsonData.subTenantDTO = subTenantDTO;
        }

        return apiApp
            .put(`/hotHoldConfig/${hotHoldConfigId}`, JSON.stringify(jsonData), {
                headers: getHeaders(),
            })
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },
        
     DashboardCleaningCompliance: (startDate, endDate) => {
        return apiApp
            .get(
                `/dashboard/cleaning-compliance?startDate=${startDate}&endDate=${endDate}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                { headers: getHeaders() }
            )
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },

    DashboardKPI: (startDate, endDate) => {
        return apiApp
            .get(
                `/dashboard/kpi?thisWeekStart=${startDate}&thisWeekEnd=${endDate}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                { headers: getHeaders() }
            )
            .then((res) => res.data)
            .catch((err) => Promise.reject(err?.response?.data));
    },


    DashboardOpeningStock: (startDate, endDate) => {
    return apiApp
        .get(
            `/dashboard/opening-stock?weekStart=${startDate}&weekEnd=${endDate}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
            { headers: getHeaders() }
        )
        .then((res) => res.data)
        .catch((err) => Promise.reject(err?.response?.data));
},

};

export default ReportsApi;